import { useEffect, useRef, useState } from "react";

export default function useScrollReveal(introDone, options = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  const triggered = useRef(false);

  useEffect(() => {
    if (!introDone) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !triggered.current) {
          triggered.current = true;
          setVisible(true);
        }
      },
      { threshold: options.threshold ?? 0.15, ...options }
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [introDone]);

  return [ref, visible];
}